<template>
  <div class="w-100 h-100 m-0" style="padding: 32px">
    <div class="row m-0 p-0 acry-page-title justify-content-center">下書き・デザイン履歴</div>
    <div class="row m-0 justify-content-center" style="padding: 40px 0px; flex-wrap: nowrap;">
        <div class="border-color"></div>
        <div
          class="tab m-0"
          :class="{ 'tab-select': isSelectDraftTab() }"
          @click="clickTabDraft"
        >
          下書き
        </div>
        <div
          class="tab m-0"
          :class="{ 'tab-select': isSelectDesignHistoryTab() }"
          @click="clickTabDesignHistory"
        >
          デザイン履歴
        </div>
        <div class="border-color"></div>
    </div>

    <div v-if="getDesignList().length != 0" class="col-12" style="height: calc(100% - 135px)">
      <div class="container scroll py-3 h-100">
        <div class="row row-cols-4">
          <div
            class="col p-1 m-0"
            v-for="item in getDesignList()"
            :key="item.designId"
            style="position: relative; aspect-ratio: 1456/2359;"
            @click="onClickDesign(item)"
          >
            <div
              class=""
              :class="{
                'border-dark border-1': selectDesign != item,
                'selectedd': selectDesign == item,
              }"
              style="background-color:lightgray;position:relative;" :style="getCanvasAspect(item)"
            >
              <img class="img-fluid design-image" style="z-index:2" :src="item.previewImagePath" />
              <img class="img-fluid design-image" style="z-index:1" :src="item.cutlineImagePath" />
              <!-- <p class="text">{{ item.designId }}</p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="nodata-text text-center m-0">
      <span v-if="this.isSelectTabDraft">下書きはありません</span>
      <span v-else>デザイン履歴はありません</span>
    </div>
  </div>
</template>

<script>
import { GetCanvasSize } from "@/js/Const.js";


export default {
  name: "CenterViewDraft_Ap",
  props: {},
  data: function () {
    return {
      isSelectTabDraft: true,
      selectDesign: null,
    };
  },
  computed: {
  },
  async created() {
    this.$store.commit("setSelectDraftDesign", null);

    this.$store.commit("showLoading");

    await this.$store.state.draftManager.update().catch((e) => {
      this.$handleError("053", e, { hideLoading: true });
    });

    // 初期状態は下書き
    this.clickTabDraft();

    this.$store.commit("hideLoading");

  },
  components: {},
  methods: {
    getDesignList() {
      return this.isSelectTabDraft
        ? this.$store.state.draftManager.draftList
        : this.$store.state.draftManager.designHistory;
    },
    clickTabDraft() {
      this.isSelectTabDraft = true;
      this.$store.commit("setSelectDraftDesign", null);
      if( this.getDesignList().length == 0 ){
        this.$store.commit("hideRightMenu");
      }else{
        this.$store.commit("showRightMenu");
      }
    },

    clickTabDesignHistory() {
      this.isSelectTabDraft = false;
      this.$store.commit("setSelectDraftDesign", null);
      if( this.getDesignList().length == 0 ){
        this.$store.commit("hideRightMenu");
      }else{
        this.$store.commit("showRightMenu");
      }
    },

    isSelectDraftTab() {
      return this.isSelectTabDraft;
    },

    isSelectDesignHistoryTab() {
      return !this.isSelectTabDraft;
    },

    onClickDesign(item) {
      this.$store.commit("setSelectDraftDesign", item);
      this.selectDesign = item;
    },

    getCanvasAspect(item){
      return { "aspect-ratio":GetCanvasSize(item.productId).width + ' / ' + GetCanvasSize(item.productId).height };
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.tab {
  width: 170px;
  height: 40px;
  color: $primary-main-color;
  border: 2px solid $primary-main-color;
  background-color: $background-white-color;
  padding: 5px;
  font-family: 'Noto Sans JP';
  font-weight: bold;
  border-radius: 0px;
}
.tab:hover{
  color: $text-white-color;
  background-color: $primary-main-color;
}
.tab-select {
  color: $text-white-color;
  background-color: $primary-main-color;
}
.border-color{
  width: 35%;
  border-bottom: 1px solid $border-main-color;
}
.nodata-text{
  font-family: 'Noto Sans JP';
  font-size: 15px;
  text-align: left;
  margin-left: -12px;
}

.design-grid {
  margin: 0% 10%;
  justify-content: center;

  overflow: scroll;
  overflow-x: hidden;
}

.design-grid-cell {
  position: relative;
  margin: 20px;
  width: 100%;
  height: 400px;
  background-color: #cccccc;
  float: left;
}

.design-image {
  position: absolute;
  left: 0px;
  top: 0px;
  // width: 100%;
  // height: 100%;
}
.scroll {
  overflow-y: scroll;
}
p.text {
  position: absolute; /*自由に配置する指定*/
  bottom: 0; /*下寄せの指定*/
  margin: 10px;
}
.selectedd {
  border: 4px solid  $border-main-color;
}
</style>
